import { GTM_EVENTS } from "@gameApp/constants";

interface Params {
  event: string;
  element_id: string;
}

/**
 * Event tracking for Google Tag Manager
 * Constants with event names are stored in the GTM_EVENTS object in the app/constants file
 */
export function sendGaEvent(params: Params): boolean {
  const { event, element_id } = params;
  if (typeof window.gtag === "function") {
    window.gtag("event", `${element_id}-${event}`);
    return true;
  }

  console.warn("window.gtag is not available");
  return false;
}

export function sendGaAdVisibleEvent(elementId: string): boolean {
  return sendGaEvent({
    event: GTM_EVENTS.AD_VISIBLE,
    element_id: elementId,
  });
}

export function sendGaAdClickEvent(elementId: string): boolean {
  return sendGaEvent({
    event: GTM_EVENTS.AD_CLICK,
    element_id: elementId,
  });
}
